module.exports={
    common:{
        connect:"お問い合わせ",
        contactUs:"お問い合わせ",
        learnMore:"詳細はこちら",
        trustedBy:"信頼される",
        sendSuccess:"送信成功!",
        sendFail:"送信失敗!",
        lang:[
            {
                value:"EN",
                name:"英語"
            },{
                value:"CHT",
                name:"繁中"
            },{
                value:"CN",
                name:"簡中"
            },{
                value:"JP",
                name:"日本語"
            }
        ]
    },
    bannerTips:{
        square:" 100万ft²の製造工場",
        production:"世界各国の合理化生産設備",
        processes:"持続可能なプロセス及び環境にやさしい材料"
    },
    footer:{
        letStarted:"始めましょう",
        signTitle:"新しいお知らせ",
        signPlaceholder:"メールアドレス",
        signBtn:"送信",
        signTips:"いつでもこれらのEメールより配信停止できます。 貴方からご提供いただいた情報は、マイタックテクノロジー京都株式会社（香港）のプライベートポリシー及び諸条件の対象となることをご了承下さい。",
        privacyPolicy:"プライバシーポリシー",
        cookiePolicy:"クッキーポリシー",
        termsOfUse:"利用規約",
        copyright:"Copyright © 2021 MPT Solution and its Affiliates and Subsidiaries. All rights reserved",
        emailrRquired:"メールボックスを空にすることはできません!",
        emailVaild:"郵箱格式不對!",
    },
    home:{
        worldMolding:{
            title:"世界有数のプラスチック成形メーカー",
            text:"マイタックテクノロジー京都株式会社は世界レベルの高い品質システムを有するプラスチック成形メーカー"
        },
        dell:{
            title:"「卓越したサポートとパフォーマンス体制を有する」",
            text:"Dell社のWWPクライアントNBメカニカル"
        },
        sevices:{
            title:"サービス",
            text:"お客様が満足できる技術サービスを提供致します。金型設計・製作、材料検討、工程検討などを提案致します。"
        },
        injectMold:{
            title:"射出成形",
            text:"マイタックテクノロジー京都株式会社は5,000件以上のアイテムと20年以上の生産実績を有し、レベルの高いサービスを提供します。"
        },
        metal:{
            title:"金属加工",
            text:"マイタックテクノロジー京都株式会社は、貴社の板金加工プロセスの全段階に対応できる完全な生産能力を備えています。"
        },
        finishing:{
            title:"仕上げサービス",
            text:"プラスティック成形から金属加工及び二次加工等、お客様にご満足いただける効率の良い生産方式を提案します。"
        }
    },
    aboutUs:{
        title:"当社は、マイタックテクノロジー京都株式会社です",
        introText:{
            no1:"マイタックテクノロジー京都株式会社は1999年以来、世界有数の企業に精密なメカニカル部品を継続的に開発しております。",
            no2:"マイタックテクノロジー京都株式会社は、高品質、高生産性を有し、高品質のコンポジェット材のメカ部品を提供するために最新鋭技術を利用した非常に高精度の仕様を提供します。 当社は、部品の品質に加え、カスタマーサービスにも力を入れます。ぜひ当社の献身的かつ革新的なチームに貴社の次のコンセプトをお任せいただき、実現させてください。",
            no3:"当社のサービス及び総合実力について、详しくはこちらをご覧ください。",
        },
        here:"ここで",
        whyWorkWithUs:"当社と提携するメリット",
        history:{
            title:"歴史",
            textNo1:"1999年に设立されたMITACプレシジョンテクノロジーコーポレーション（マイタックテクノロジー京都株式会社）は、现在世界有数のデザイン及び制造能力を有する企业としてよく知られており、国际的な大手会社（国内外の世界をリードする企业や一流OEM/ODM制造业者）と长年にわたり提携している経験を有します。",
            textNo2:"2007年に、MPTは、台湾の上场企业であるGetacテクノロジーと正式に合并しました。豊富な财政能力や电子制品の研究开発能力により、さらに完璧なメカニカル部品统合ソリューションを提供することができるようになりました。",
            textNo3:"2009年に、世界の三番目の合金机构部品会社Wafferに投资して、MPTは、軽金属合金部品の制造能力をさらに高めました。"
        }
    },
    affiliates:{
        title:"関連会社",
        introText:"マイタックテクノロジー京都株式会社は、1989年に創設された多国籍事業グループであるGetacグループの子会社です。 Getacの事業範囲は、コンスーマーエレクトロニクス、ITチャネル、システム統合、ソフトウェア開発、石油化学業界、産業用ガス、及び食物加工業界に及びます"
    },
    coreCompetencies:{
        title:"コア・コンピテンシー",
        prototypingServices:{
            title:"PROTOTYPING:",
            textList:[
                '3Dプリンター（プラスティック及び金属）',
                'CNC',
                '樹脂材・ゴム材の快速金型',
                'プレス',
                '表面処理',
                '試作型'
            ]
        },
        manufacturingServices:{
            title:"製造サービス:",
            textList:[
                '金型生産能力',
                '量産生産',
                'ロット生産',
                '表面処理',
                '組立',
                '梱包',
                '工業自動化 (A.I.+IoT)'
            ]
        },
        integrationSolutions:{
            title:"統合対策:",
            textList:[
                '統合の共同開発',
                'CMFの共同開発',
                'メカ部品共同開発',
                '製造プロセス開発',
                '材料開発'
            ]
        },
        testingCertification:{
            title:"テスト及び認証:",
            textList:[
                'メカ部品テスト',
                'プラスチック材料の試験',
                '環境的シミュレーション',
                '地域の安全性認証'
            ]
        }
    },
    sustainability:{
        title:" サステナビリティ",
        carbonFootprint:"「カーボンフットプリント」は、世界的な一流企業が研究開発している環境保護トレンドの一つです。そのため、マイタックテクノロジー京都株式会社では、環境保護に関する企業の役割を一貫して担っています。",
        pdaComponent:"マイタックテクノロジー京都株式会社は、2011年4月に「PDAコンポネント製品」の使用を開始し、カーボンフットプリント計画の実行に成功しています。カーボンフットプリント算出ガイドラインのもと、DPAコンポネント製品は、原材料、加工及び輸送の3段階の完全なライフサイクルにおいて温室効果ガスの二酸化炭素換算値8.741kgCO2e/unitを生成することが示され、大量のカーボン排出量が加工段階で作られており、排出量全体の82.12%を占めます。原材料段階では17.87%、輸送段階では0.01%です。 これは、環境保全を真に実現するために、製品加工段階でグリーンプロセスプランニングを強化する必要があることを示しています。",
        frontrunner:"マイタックテクノロジー京都株式会社は、環境保全方針のフロントランナーとして、お客様にサービスを提供し、お客様と協力してより環境に配慮した、環境にやさしい製品を生み出す力を蓄積してきました。"
    },
    integrityManagement:{
        title:"誠実経営",
    },
    sustainableReport:{
        title:"永続的なレポート",
        csrTitle:"CSR報告書",
        zcTitle:"政策と宣言"
    },
    technologySolutions:{
        title:"提案",
        introText:"マイタックテクノロジー京都株式会社は、最新の技術により、高品質、高生産率機構部品を提供します。 当社独自の改良された製造プロセス及び革新的な生産技術により、お客様ご満足いただける精度の高い部品をお届けすることができます。"
    },
    injectionMolding:{
        title:"射出成形",
        introText:"マイタックテクノロジー京都株式會社は、高品質の射出成形サービスの分野で業界をリードしています。 5,000件以上の金型と20年以上の成形実績を有し、設計から金型製造、成形まで全體的な対策を提供できます。"
    },
    cosmeticFinishing:{
        title:"表面処理",
        introText:"マイタックテクノロジー京都株式會社は、各種類の表面加工処理技術を持って、高品質の體裁部品が生産できます。"
    },
    metalFabrication:{
        title:"金属加工",
        introText:"マイタックテクノロジー京都株式会社は、貴社の板金加工プロセスの全段階に対応できるフル キャパを持っております。"
    },
    composite:{
        title:"コンポジェット材",
        introText:"マイタックテクノロジー京都株式会社の提案により、コンポジェット材でより手軽、坚固な部品を设计して制作することが可能です。"
    },
    material:{
        title:"材料",
        introText:"マイタックテクノロジー京都株式会社は、ポストコンシューマーリサイクル（PCR）材の認定製造業者です。 当社は、材料開発から承認及びプロパティテストまで、完全に社内で特許を持っています。"
    },
    capabilities:{
        trustedBy:"信頼される",
        ourCapabilities:{
            title:"當社の能力",
            introText:"マイタックテクノロジー京都株式會社は、最先端の技術により、高品質、高歩留で、お客様の各種ニーズに対応したメカ部品を提供します。獨自の優良製造プロセス及び革新的な大量生産技術により、當社はお客様にご満足いただける精度の高いメカ部品をお屆けいたします。アジアで複數の製造工場が有り、及び20年以上にわたる実績により、當社は、世界をリードする企業に広範囲の機械対策を提供します。當社のコア・コンピテンシーに関する詳しい內容はこちらをご覧ください。",
            fullList:"フル装備一覧"
        },
        engineeringConsulting:{
            title:"エンジニアリング及びコンサルティング",
            introText:"200人以上の認定エンジニアと20年以上にわたる部品開発実績を持っているからこそ、當社は、禦社開発速度UPとCOST DOWNの能力を持っています。"           
        },
        certifications:{
            title:"認証",
            introText:"マイタックテクノロジー京都株式會社は、ISO及びIATFに認定されています。 品質は、當社の最優先事項です。 當社の認証に関する詳しい內容はこちらをご覧ください。"
        },
        massProduction:{
            title:"量産",
            introText:"マイタックテクノロジー京都株式會社は、過去20年以上にわたり、世界有數の企業とパーツの獨佔的パートナーとして協力しました。"
        },
        automation:{
            title:"自動化",
            introText:"マイタックテクノロジー京都株式會社は、業界內で早めに自動化生産システムを導入した企業です。 この自動化システムにより、當社は、生産を加速することができます。"
        }
    },
    certifications:{
        title:"認証",
        itemList:[
            "TUV NordによるISO9001認証(2007年)",
            "TUV NordによるISO14001認証(2007年)",
            "TUV Nordによる労働安全マネジメントシステム（OHSAS）18000認証(2007年)",
            "NIKよりグリーンサプライヤー認証合格（2010年）",
            "キヤノン（Canon）によるGP認証（2010年）",
            "BSIによるISO9001認証(2010年)",
            "BSIによるISO14001認証(2010年)",
            "BSIによるISO 18001認証（2010年）",
            "キヤノン（Canon）によるGP認証（2013年）",
            "BSIによるISO14001認証(2013年)",
            "BSIによるISO18001認証(2013年)",
            "BSIによるISO 9001認証（2013年）",
            "SGSによるISO/TS 16949認証（2014年）",
            "BSIによるISO14001認証(2016年)",
            "BSIによるISO 18001認証（2016年）",
            "SGSによるISO9001認証(2018年)",
            "SGSによる国際自動車タスクフォース（IATF）16949認証(2018年)",
            "BSIによるISO45001認証(2018年)",
            "BSIによるOHSAS 18001認証（2018年）",
            "グリーンパートナー認証のソニー（2019年）",
            "TUVによるレスポンシブ・ビジネス・アラインス（RBA）検証済監査プログラム（VAP）ゴールド(2020年）",
            "IATF 16949ドイツラインTUV認証（2021年）"
        ]
    },
    engineeringConsulting:{
        title:"全てのデザインに組み込まれた卓越性とイノベーション構築",
        introText:"マイタックテクノロジー京都株式会社はイノベーションが企業成長に重要であると信じています。 競争優位性を獲得するために、貴社の次のコンセプトをお任せください。当社と共に、実現させましょう。"
    },
    testingLab:{
        title:"試験実験室",
        introText:"当社は、中国合格評価認定委員会（CNAS）実験室に認定された試験室を持っています。研究開発に十分に投資し、本格的な試験実験室では、お客様に材料の全面的な特性を分析します。",
        mechanical:{
            title:"機構的なテスト:",
            text:   "• 引張及び曲げ試験<br>"+
                    "• 機構的なテスト<br>"+
                    "• シャルピー及びアイゾット衝撃<br>"+
                    "• 引張降伏及び伸長<br>"+
                    "• マイクロ　ハードネス<br>"+
                    "• マルチエレメントコンテンツ金属平板及び故障解析<br>"+
                    "• 実装及び研磨<br>"+
                    "• 顕微鏡検査<br>"+
                    "• 微細構造及びエレメント解析"
        },
        material:{
            title:"プラスチック材料試験:",
            text:"• 熱重量分析（TGA） <br> "+
                "• 示差走査熱量測定（DSC） <br>" +
                "• フーリエ変換分光光度計 <br>"+
                "• HDTビカットテスト <br>"+
                "• メルトフローレート <br>"+
                "• 耐燃試験（（UL）試験）<br>"+
                "• 加工及びレオロジー特性（ハーケ（HAAKE）レオメーター）"
        },
        environmental:{
            title:"環境的シミュレーション: ",
            text:   "• 塩水噴霧室 <br>"+
                    "• 温湿度室 <br>"+
                    "• 熱衝撃室"
        },
        other:{
            title:"その他試験:",
            text:   "• 電気化学ワークステーション <br>"+
                    "• 光沢試験 <br>"+
                    "• 鉛筆硬度試験 <br>"+
                    "• 根本原因解析（RCA）試験 <br>"+
                    "• 測色計 <br>"+
                    "• 抵抗試験 <br>"+
                    "• ショアA硬度試験"
        }
    },
    prototyping:{
        title:"PROTOTYPING",
        introTtile:"貴社のアイデアを現実にする",
        introText:"モークアップ作成は以前より隨分簡単なことになりました。弊社は速やかに高精度、高品質の部品が製作できるので、ぜひ弊社を利用してください！",
        tips:"マイタックテクノロジー京都株式會社のモークアップ製作部門は、お客様のニーズにより、快速なソリューションが提供できます。例えば、CNC、3Dプリンター、ウレタン鋳造、熱成形など。"
    },
    locations:{
        title:"场所",
        introText:"当社は、部品制造事业への情热や専门性をもつ多くの正社员を有しており、皆が现在の课题に取り组むため革新的な制造プロセス及び材料の开発に専念しています。<br>先进的なエンジニアリングおよびグローバルな制造拠点:"
    },
    FAQ:{
        title:"よくあるご質問",
        introText:"皆様から何か質問があったら、ここで回答します。もしここで御社の質問を見なければ、お問い合わせページにご連絡ください。"
    },
    contactUs:{
        title:"お問い合わせ",
        firstName:"名前",
        lastName:"苗字",
        email:"Eメール",
        message:"メッセージ",
        additionalDetails:"ほかの情報",
        sendMessage:"送信",
        howHelp:"お客様のご要望をお知らせください。",
        trustedBy:"信頼"
    },
    privacyPolicy:{
        title:"プライバシーポリシー",
        A:{
            title:"A. 本プライバシー通知",
            textItem:[
                "MPT Solution (HK) Limited及びその子会社である(MPT Solution)は、個人や機密の個人データのプライバシーを保護することに専念し、世界中の他の国々の準拠法とともに、UKデータ保護法2018やEU一般データ保護規制（GDPR）に準拠しています。 このプライバシー通知は、MPT Solutionが処理する個人や機密の個人データを有する全ての個人にオープンかつ公正になるように、及び個人データがどのように処理されるか及びその対応方法に関する詳細を提供するために、MPT Solutionの義務の一部を構成します。",
                "MPT Solutionは、お客様及びパートナーの氏名、連絡先、Eメールアドレスなどの個人データを処理します。 データ処理とは、収集、保管、使用、開示又は個々の個人データの配置を意味します。",
                "MPT Solution会社のソリューションやサービス又はウェブサイトを利用する既存又は潜在的なお客様及びパートナー個人には、別途補足的通知を含む追加的プライバシー通知が提供されます。 これらの追加プライバシー通知は、本プライバシーポリシーを補足するものとします。",
                "このプライバシー通知は、MPT Solutionによる個人データの処理に関するものです。 特段の記述がない限り、「当社」又は「当社の」の全ての参照は、個人又は機密個人データを処理する全てのMPT Solutionの事業を意味します。 このプライバシー通知は、消費者及び当社ウェブサイトの訪問者（共に「貴方」）を含む、当社が関わった当社の組織外の個人を対象とします。 このプライバシー通知で使用される定義済条件は、下記セクション（Q）で説明があります。",
                "MPT Solutionは、このプライバシー通知を行う上で、データ管理者です。 連絡先の詳細は、下記セクション（N）で説明があります。",
                "このプライバシー通知は、個人データを処理、又は準拠法の変更に関して当社の慣例の変更を反映するために適宜改正又は更新がおこなわれます。 このプライバシー通知を注意深くお読みいただき、このプライバシー通知の条件に従い、当社が行う可能性のある変更点を更新するためにこのページを定期的にチェックしていただくことをお勧めします。",
                "このプライバシー通知に記載されるリスト又は例は、全ての個人を関して網羅しているわけでなく、又は正式に代表しているわけでもありません。"
            ],
            scope:{
                title:"範囲",
                textItem:[
                    "このプライバシー通知の範囲は、下記に関するお客様（既存及び潜在）及びパートナー（既存及び潜在）の個人データに及びます。",
                    "•&nbsp;&nbsp;&nbsp;&nbsp;個人データの収集 <br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;個人データの処理<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;個人データの使用<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;個人データの開示<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;国際データの移動<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;データの正確性<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;データの最小化<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;個人データの保持<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;個人データの確保<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;データ主体の権利<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;クッキー<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;連絡先詳細<br/>"+
                    "•&nbsp;&nbsp;&nbsp;&nbsp;苦情"
                ]
            }
        },
        B:{
            title:"B. 個人データの収集",
            textItem:[
                "当社は、ユーザーに関する個人データ（氏名、住所、連絡先）を収集します。個人データの 収集する本源：",
                "•&nbsp;&nbsp;&nbsp;&nbsp;提供していただいた個人データ（例、Eメール又は電話、若しくは他の連絡手段）<br/>•&nbsp;&nbsp;&nbsp;&nbsp;ユーザーと当社の関係における通常の過程で提供して頂いた個人データ（例、当社から製品又はサービスを購入する際）<br/>•&nbsp;&nbsp;&nbsp;&nbsp;ユーザーのプロフィールを公然に可視化されるために選択するソーシャルメディア経由を含む、ユーザーが明白に公表することを選択する個人データ<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が第三者かあら受領する個人データ（例、パートナー、信用照会機関、法律執行機関など）<br/>•&nbsp;&nbsp;&nbsp;&nbsp;ユーザーがマイタックテクノロジー京都株式会社のウェブサイトを訪問する又はサイト上で利用可能な若しくはサイトを通じて特集又はリソースを使用する際にユーザーから得る個人データ ユーザーがサイトを訪問する際に、ユーザーのデバイスやブラウザが自動的に一定の情報（デバイスのタイプ、運用システム、ブラウザのタイプ、ブラウザ設定、IPアドレス、言語設定、サイト及び他のテクニカルコミュニケーション情報に接続する日時及び時間）を開示。",
                "当社はまた、ユーザーに関する個人情報（当社と係わった記録など）、及び下記を対象とするユーザーの購入履歴の詳細データを作成する場合があります。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;個人の詳細：名前、ニックネーム、性別、生年月日、年齢、国籍、写真<br/>•&nbsp;&nbsp;&nbsp;&nbsp;連絡先詳細：住所、電話番号、Eメールアドレス、ソーシャルメディアプロフィール詳細<br/>•&nbsp;&nbsp;&nbsp;&nbsp;支払い詳細：請求書送付先住所、銀行口座番号又はクレジットカード番号、カード保有者又は口座保有者の氏名、カード又は口座セキュリティ詳細、カードの有効日時、カード終了日時<br/>•&nbsp;&nbsp;&nbsp;&nbsp;見解及び意見：ユーザーが当社に送付するために選択する、又はソーシャルメディア上で当社に関して公に投稿する見解及び意見"
            ]
        },
        C:{
            title:"C. 個人データの処理",
            textItem:[
                "当社は、ユーザーの個人データの処理に関して法的根拠として下記を利用します。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;完全に自発的である処理に関してのみ利用されるこの処理に対するユーザーの事前の明示的な同意を付与していただきます。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;ユーザーが当社と締結するかもしれないいかなる契約書に関してもこの処理が必要です。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;この処理は、準拠法により要求されます。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社は、事業を管理、運営又は促進する目的で、この正当な利益がユーザーの利益、基本的権利又は自由により優先されない場合、この処理を実行する正当な利益を有します。"
            ]
        },
        D:{
            title:"D. 個人データの使用",
            textItem:[
                "当社は、下記のためにユーザーの個人データを使用する場合があります。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;当社サイトの運用及び管理：貴方に内容を提供する、ユーザーに広告及び他の情報を表示する、当社サイトを通じてユーザーとコミュニケーションを取り、係わりを持つ場合。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;貴方に製品及びサービスの提供：ユーザーに当社のサイトや他のサービスを提供する、ユーザーが購入した製品を貴方に提供する、ユーザーからの依頼があった場合に販促品を提供する、これらの製品やサービスに関して貴方とコミュニケーションを取る場合。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;マーケッティングコミュニケーション：任意の方法（Eメール、電話、テキストメッセージ、ソーシャルメディア、投稿又は個人的連絡を含む）によりユーザーとコミュニケーションを取る場合で、ユーザーが興味のあるニュース及び他の情報。なお、このコミュニケーションは、準拠法に従いユーザーに提供されることを確認することを条件とします。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;コミュニケーション及びIT運営：当社コミュニケーションシステムの管理、ITセキュリティの運営、及びITセキュリティ監査。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;健康及び安全性：健康及び安全性査定及び記録の保管、及び関連する法的義務のコンプライアンス。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;財務管理：売上、財務、法人監査、及びベンダー管理。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;調査：当社の製品及びサービスに関するユーザーの見解を得るため。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社の製品及びサービスの改善：既存製品及びサービスの問題を特定する、既存製品及びサービスの改善点を立案する、新製品及びサービスを作成する場合。"
            ]
        },
        E:{
            title:"E. 個人データの開示",
            textItem:[
                "当社は、Getacグループ内の他の事業体にユーザーの個人データを開示する場合があります（ユーザーにサービスを提供する又は当社サイトの運営を含む）。",
                "さらに、当社は、下記にユーザーの個人データを開示する場合があります。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;法的及び規制当局：依頼がある場合、又は準拠法又は規制の実際の違反又は違反の疑いを報告するため。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;会計士、監査人、弁護士及びマイタックテクノロジー京都株式会社の外部専門家。なお、秘密保持に関する契約義務の拘束を条件とする。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;契約を締結するために貴方の事前依頼時に措置を取る、又はユーザーの依頼時に契約の履行をするために、マイタックテクノロジー京都株式会社の再販業者、配送業者及び第三者のビジネスパートナー。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;世界各地の第三者処理業者（支払いサービス提供者、海運会社、テレマーケティング会社、データ供給サービスプロバイダー、データクレンジングサービスプロバイダー、等）。なお、このセクション（E）の下記に記載された必修要件を条件とする。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;関連当事者、法的執行機関又は裁判所、法的権利の立証、執行又は弁護のために必要な範囲。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;秘密保持に関する公安の拘束する契約義務に対する脅威に対する保護及び防御を含む、犯罪行為の防御、調査、発見又は起訴若しくは刑罰の執行のための関連当事者。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が、事業又は資産の全て又はその一部を売却又は譲渡する場合（組織再編、解散又は清算の場合を含む）の関連第三取得業者。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;第三者のプラグイン又はコンテント（例、Linkedin、ユーチューブ、及びフェイスブック）を使用し、当社サイト上で利用可能なソーシャルメディアプラットフォームの第三者プロバイダー。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が、ユーザーの個人データを処理するために第三者処理業者を雇用する場合、この処理業者は、下記を行うために契約義務に拘束することを条件とします。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社の事前の書面による指示書に従い個人データを処理のみを行う。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;個人データの秘密保持及びセキュリティを保護する対応策を使用する。準拠法に基づく追加要件と共に使用する。" 
            ]
        },
        F:{
            title:"F. 個人データの海外移動",
            textItem:[
                "当社事業の国際的な性質があるために、当社はこのプライバシー通知に規定される目的に関連して、上記のセクション（D）に記載通りGetacグループ内及び第三者にユーザーの個人データを移動する必要があります。 この理由のために、当社は、ユーザーが居住する国に適用するデータと異なる法律及びデータ保護コンプライアンス要件を有する他の国にユーザーの個人データを移動する場合があります。 これは、欧州経済領域（EEA）の外部に個人データの移動、処理、保管を含みます。",
                "当社が、他国にユーザーの個人データを移動する場合、標準的契約条項に基づいて行います。 ユーザーは、下記のセクション（N）に記載される連絡先詳細を使用し、当社の標準的契約条項の写しを依頼する場合があります。",
                "ユーザーにサービスを提供する一環として、当社は、下記に記述されるEEA外部の第三者データ処理業者を利用します。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;米国を拠点とするお客様、パートナー及び連絡管理用のセールスフォース・ドットコム。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;米国を拠点とする設備配送やサービスサポート向けのフェデェクス。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;米国を拠点とするマーケティングキャンペーン向けのロケットサイエンスグループ。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;米国を拠点とするサービスの支払い向けにペイパル社。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;米国を拠点とするクラウドサービス用にアマゾンウェブサービス。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;米国を拠点とするクラウドサービス用にマイクロソフトコーポレーション（マイクロソフトアジュール）。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;EEA外部の第三者データ処理業者に関する詳細及び当社とのデータ保護契約書の写しを得る場合、下記のセクション（N）に記載の連絡先詳細にお問い合わせ下さい。"
            ]
        },
        G:{
            title:"G. データの正確性",
            textItem:[
                "当社は、下記を行うためにあらゆる妥当な措置を取ります。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;ユーザーの個人データは、正確かつユーザーが当社に通知する変更点を常に把握しています。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社は、ユーザーが当社に通知する不正確な個人データを削減する又は改正します。",
                "当社は適宜、ユーザーの個人データの正確性を確認するためにユーザーに尋ねる場合があります。"
            ]
        },
        H:{
            title:"H. データの最小化",
            textItem:"当社が処理するユーザーの個人データが、このプライバシー通知に規定される目的に関連して合理的に要求される個人データに限定されることを確認するためのあらゆる合理的な措置を取ります。"
        },
        I:{
            title:"I. データ保存",
            textItem:[
                "当社がユーザーの個人データを保持する持続期間を決定する基準は、下記の通りです。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;当社は、データを使用する目的に関連して必要である限りのみ身分証明を許可する形式でユーザーの個人データの写しを保持します。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;準拠法は、長期の保持期間を求めています。 特に、当社は、法的権利を制定、執行又は防御するために必要な持続期間中にユーザーの個人データを保持します。"
            ]
        },
        J:{
            title:"J. 個人データの確保",
            textItem:[
                "マイタックテクノロジー京都株式会社が、個人データの管理者として行動する場合、ユーザーの個人データへの不当なアクセス、損失、悪用又は変更を防ぐために必要かつ十分な保護手段が実行されることを確保します。",
                "当社は、関連するアクセス及びファイヤーウォール管理を有するセキュアサーバーに関する全ての個人情報を保管します。",
                "書面やEメールのどちらかで、当社に送られる個人データは、転送中に安全性に欠ける場合があり、送付の保証はできません。",
                "パスワードは、機密を保たなければならず、第三者に開示してはなりません。 マイタックテクノロジー京都株式会社は、ユーザーにパスワードを尋ねることはありません。"
            ]
        },
        K:{
            title:"K. データ主体の権利",
            textItem:[
                "ユーザーの国籍（例えば、欧州市民）に基づいた準拠法や居住地に従い、ユーザーは、下記を含むユーザーの個人データの処理に関する権利数を所有する場合があります。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;当社が処理する又は管理するユーザーの個人データへのアクセス又はその写しを依頼する権利。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が処理する又は管理するユーザーの個人データの不正確性の改正を依頼する権利。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が処理する又は管理するユーザーの個人データの削減。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が処理する又は管理するユーザーの個人データの処理制限。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社により又は当社の代わりにユーザーの個人データの処理に関して、正当な理由で反対する権利。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社が処理する又は管理するユーザーの個人データを適用可能な範囲で別の管理者に移動させるための権利。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社がユーザーの同意の下、ユーザーの個人データを処理する場合、この同意を撤回する権利。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社よる又は当社の代わりにユーザーの個人データを処理することに関して、データ保護当局に苦情を提出する権利。",
                "これは、ユーザーの法的権利には影響ありません。",
                "これらの権利の内一つかそれ以上を執行するため、若しくはこれらの権利又はこのプライバシー通知の他の条項又はユーザーの個人データの当社の処理の仕方について質問するため、下記のセクション（N）に記載の連絡先詳細にお問い合わせください。"
            ]
        },
        L:{
            title:"L. クッキー",
            textItem:"クッキーとは、ユーザーがウェブサイト（当社サイトを含む）を閲覧する際にデバイス上に置かれる小さいファイルです。 ユーザーのデバイス、ブラウザ、また場合によっては、ユーザーの好み及びブラウジング習慣について情報を記録します。 当社は、クッキーポリシーに従いクッキー技術を通じてユーザーの個人データを処理する場合があります。 クッキーの使用方法の詳細情報に関して、当社のクッキーポリシーをご覧下さい。"
        },
        M:{
            title:"M. 利用規約",
            textItem:"当社サイトの全ての利用は、利用規約の対象となります。"
        },
        N:{
            title:"N.  連絡先詳細",
            textItem:"このプライバシー通知について何かコメント、質問又は懸念事項、若しくはマイタックテクノロジー京都株式会社の個人データを処理方法に関する他の問題がありましたら、下記にご連絡下さい。",
            contact:"法務センター 〒11568<br/>台北市南港区 南港路一段 209号<br/>A棟 ５F台湾<br/>受信者：データ保護部長宛<br/>Eメール： dpm.LAC@getac.com.tw<br/>電話: ＋886(0)2 2785 7888"
        }
    },
    cookiePolicy:{
        title:"クッキーポリシー",
        textItem:"このクッキーポリシーは、このポリシーの末尾に記載のウェブサイトに適用し、MPT Solution(HK)（その会社自身、及びその関連会社を含む）（共に、 MPT Solution ）により運営され、管理されます。",
        which:{
            title:"このポリシーが適用するウェブサイト",
            textItem:[
                "このポリシーは、Getac及びMPT Solutionにより運営され、管理される下記のウェブサイトに適用します。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;http://www.mpt-solution.com<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://de.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://en.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://es.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://fr.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://intl.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://it.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://ru.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://getac.co.uk/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://latam.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://tw.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://www.getac.com.cn/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://apac.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://us.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://mx.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://www.getac.com.mx/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://be.getac.com/index.html<br/>•&nbsp;&nbsp;&nbsp;&nbsp;https://www.getacestore.com/<br/>•&nbsp;&nbsp;&nbsp;&nbsp;https://partners.getac.com<br/>•&nbsp;&nbsp;&nbsp;&nbsp;http://rma.getac.com"
            ]
        },
        what:{
            title:"クッキーとは？",
            textItem:[
                "クッキーは、ユーザーが、ウェブサイトを利用する際に、コンピューター又は他のデバイスに保管される小さいテキストファイルです。 それらは、通常、ウェブサイトを機能させ、ユーザーのウェブサイト内の動きを追跡し、詳細なログイン情報等を記録する。",
                "Cookieは起源、機能、寿命によって、いくつのタイプに分類されています。クッキーの重要特徴は以下を含みます。",
                "•&nbsp;&nbsp;&nbsp;&nbsp;第一方 Cookie は、ユーザーが訪問しているウェブサイトにより置かれるクッキーで、第三方は、 Cookie は、ユーザーが訪問している以外のウェブサイトに置かれるものです。当社は、第三方の収集又は使用について、コントロールでいない。 <br/>",
                "必須のCookie - これらのCookieは、Webサイトの閲覧やサイト機能の利用時に不可欠です。",
                "パフォーマンスクッキーは、利用者の数、ウブラウザの時間及びエラーメッセージなどウェブサイト上のパフォーマンスに関するデータを収集します。",
                "機能性Cookie、過去に利用者が当サイト内で行った選択、例えば表示言語、サイト再訪問時に表示される地域サイト、自動ログイン用のユーザー名やパスワードといった情報を、Webサイトが記憶できるようになります。",
                "目標/広告性クッキーにより、ウェブサイトが個人的な広告を送信することが可能になります。",
                "セッションクッキーは一時的なクッキーであり、ブラウザを閉じる時、削除されますが、持続的または永続的なクッキーは、手動で削除するか、指定した永続的なCookieファイルに従ってブラウザが削除されるまでデバイスに残ります。",
                "クッキーの全ての側面に関する詳細な情報は、www.allaboutcookie.orgでご覧ください。 MPT Solutionは、この第三者のウェブサイトと提携関係はなく、責任を負わないことにご留意ください。"
            ]
        },
        why:{
            title:"なぜ、クッキーを使用するのでしょうか？",
            textItem:[
                "Cookie使用目的については、以下の通りです:",
                "•&nbsp;&nbsp;&nbsp;&nbsp;使用者を区別する。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;当社ウェブサイトの使用及び機能性を改善する。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;使用者のニーズや好みに合わせて、ウェブサイト及び製品を制定する。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;サイトの利用方法や匿名編集および集計まとめを分析する。<br/>•&nbsp;&nbsp;&nbsp;&nbsp;これらの情報は、いずれも個人を特定するものではありません。情報はすべて集約されるため、結果として匿名化されます。"
            ]
        },
        whatTypes:{
            title:"当社が使用するクッキーの種類について。",
            textItem:[
                "このウェブサイト上で使用されるクッキーは、下記の一覧表になります。",
                "クッキー関して、及び他の目的のために処理される使用者の個人データは、当社のプライバシーポリシーに準拠することにご留意ください。",
                "さらに、当社では、クッキーに加えて又は合わせて、ウェブビーコン（クリアGIF）及び他の類似した技術を使用する場合があります。 ウェブビーコンは、通常、サイト上やEメールに置かれる透明のグラフィック画像（通常1ピクセルx1ピクセル）であり、当社ウェブサイトの訪問者の行動を理解するために役立ちます。 ウェブビーコンに関する詳細な情報は、http://www.allaboutcookies.org/web-beacons/.でご覧いただけます。MPT Solutionは、この第三者ウェブサイトと提携関係にはなく、責任を負わないことにご留意ください。"
            ]
        },
        howCan:{
            title:"クッキーやウェブビーコンをどのように管理しますか？",
            textItem:[
                "ほとんどのインターネットでは、クッキーを自動的に受け入れる設定になっています。 ブラウザに応じて、クッキーを受け入れる前に貴方に警告するようにのブラウザを設定する又はそれらを拒否するように設定することができます。 この取り扱い方法についての詳細は、ブラウザ上で「ヘルプ」ボタン（まはた同様のボタン）を参照して下さい。",
                "無効なクッキーは、当社ウェブサイト上のユーザー体験に影響を与える場合があります。",
                "違うデバイスで弊社ウェブサイトへアクセス場合、各デバイスのブラウザがご好みのクッキーに設定することを確報する。",
                "クッキーの管理方法に管理する詳細情報は、http://www.allaboutcookie.org/manage-cookie/ から利用可能です。  MPT Solutionは、この第三者のウェブサイトと提携関係はなく、責任を負わないことをご留意ください。",
                "さらに、下記のサイトに訪問し、下記から配信停止したい会社のクッキーを選択することでクッキーから配信停止できます。http://www.aboutads.info/choices/#completed 及び http://www.youronlinechoices.com/. MPT Solutionは、これらの第三者ウェブサイトと提携関係はなく、責任を負わないことをご留意ください。"
            ]
        }
    },
    termsUse:{
        title:"利用規約",
        textItem:"これらの利用規約（以下、「利用規約」と称する）は、MPT Solution (HK) Limited ）及びその関係会社（以下、「MPT Solution」と称する）のウェブサイトmpt-solution.com（以下、「ウェブサイト」と称する）にのみ適用可能です。 このウェブサイト上の個別ページ又は資料は、それぞれ個別の諸条件がつくことにご留意下さい。 このウェブサイト上のページ又は資料の使用時は、上記の個別の諸条件並び利用規約に従ってください。 使用条件と上記の個別の諸条件の間に何か衝突点がある場合、この個別の諸条件を準にしてください。",
        accessing:{
            title:"1. ウェブサイトへのアクセス",
            textItem:[
                "このウェブサイトにアクセス及び使用する場合、下記の利用規約及び本契約に含まれる全ての諸条件又はウェブサイトに規定される個別の諸条件を守て下さい。当該条件は、使用者より受け入れられるものと見なされます。 全ての利用規約に同意しない場合、このウェブサイトを使用しないでください。",
                "MPT Solution はいつでもこれらの利用規約を改正することができます。 改正後の利用規約は、このウェブサイトに公開された直後に効力を持つものします。 このウェブサイトへのアクセス及び使用を管理する全ての条件が把握漏れないため、定期的にウェブサイトに公開される利用規約を確認して下さい。 他のMPT Solutionのウェブサイトは、当該ウェブサイトに適用する独自の利用規約を有する場合があります。"
            ]
        },
        legal:{
            title:"2. 免责声明や責任制限",
            textItem:[
                "このウェブサイトに記述される全ての内容及び他の情報は、「現状有姿」のままで提供されます。 MPT Solutionは、市場性、特定の目的の適合性、非侵害、又はこのウェブサイト又はその内容の運営若しくは他の情報に関する保証を含むがこれに限ることなく、明示又は黙示を問わず、何ら表明又は保証することを否認します。 MPT Solutionは、このウェブサイトのセキュリティに関して保証又は表明をしません。 ユーザーは、送信された何らかの情報が、妨害される場合があることを承認します。 MPT Solutionは、このウェブサイトを利用可能とするウェブサイト及びサービス若しくはMPT Solutionにより送信された電子コミュニケーションは、ウィルス又は他の有害要素から免れることを保証しません。",
                "MPT Solutionは、ウェブサイト上に公表されたいかなる情報の正確性、信頼性又はタイムラインも保証せず、このウェブサイトに関連する内容、見解、製品又はサービスも支持をせず、及び当該情報の正確性、信頼性又はタイムラインを信頼することで生じる損失に対して責任を負いません。 当該情報の一部は、不正確又は現在のものでない場合があります。 このウェブサイトから得るいかなる情報に依存する者又は事業体も、自らのリスクで対応するものとします。",
                "MPT Solutionは、事前の通知なく、いつでもウェブサイト又は本契約のフォーマットのあらゆる内容又は情報を変更する又は更新する権利を留保します。 MPT Solutionは、独自の裁量により、何らかの理由によりこのウェブサイトへのユーザーのアクセスを終了する又は制限するための権利を留保します。",
                "いかなる場合であっても、MPT Solutionはその関連会社は、このウェブサイト又はその内容の使用若しくはその使用から生じる、又は関連する直接的、間接的、派生的、懲罰的、特別又は付随的損害（事業、契約、収益、データ、情報又は事業中断による損失を含むがこれに限らない）に関してたとえマイタックテクノロジー京都株式会社が、当該損害の可能性を通知されていたとしても、一切責任を負わないものとします。 このウェブサイトに関係する又は関連するMPT Solutionに対して提起される法的措置は、法的措置の原因が生じた日時後の1年以内に書面により開始され、通知されなければなりません。 このウェブサイトからの内容、情報又はサービスを使用することで、設備又はデータに関するアフターサービス、修正又は改正を必要とすることになる場合、ユーザーは全額を支払うものとします。",
                "このウェブサイトは、MPT Solutionの管理下ではない他のウェブサイトにリンクを提供する場合があります。 MPT Solutionは、他のウェブサイトの内容に対して責任を負わないものとします。 MPT Solutionは、このウェブサイトのユーザーに対する利便性としてこのリンクを提供します。そして当該ウェブサイトへのリンクの取り込みは、当該ウェブサイトの内容に関するマイタックテクノロジー京都株式会社の支持を意味するものではありません。"
            ]
        },
        copyright:{
            title:"3. 著作権",
            textItem:"ウェブサイト及びそれに記述される全ての資料（ソフトウェア、ビデオ、テキスト、画像及び写真を含むがこれに限らない）用の著作権及び全ての他の所有権（以下、「内容」と称する）は、マイタックテクノロジー京都株式会社、その関連会社又はそのライセンサーのままです。 本契約で明示的に許諾されない内容の全ての権利は、留保されます。 特段の記述がない限り、このウェブサイトに公開される内容は、非営利使用の個人のみに修正されない形式で再生産又は配布される場合があります。マイタックテクノロジー京都株式会社の事前の書面による同意なしに、配布、複製、変更、表示、または送信を含むがこれらに限定されないコンテンツのその他を使用することは固く禁じられています。 全ての著作権及び他の所有権の通知は、全ての再生産で保持されるものとします。"
        },
        trademark:{
            title:"4. 商標、商号、トレードドレス、著作権及び知的財産",
            textItem:[
                "MPT Solutionの商標、商号、トレードドレス、著作権及び知的財産は、貴重な資産であり、当社は、それらをしっかりと保護するために作業を行います。 従って、再販業者、配達業者又はインテグレータは、いかなる場合でも、特に、MPT Solutionの事前の正式な書面による同意なしに本契約に含まれるMPT Solutionのマーク又は他の所有権通知を取り除く、改変する、又は隠すことでMPT Solutionの製品又は包装を損ねる又は改変することはできません。 製品の不正な改名又はラベルの張替え並び製品を特定するために習慣的に使用される条件の消失の原因は、MPT Solutionの知的財産及び権利を侵害します。",
                "商標、商号、トレードドレス、著作権及び知的財産に関するご質問がある場合、MPT Solutionにお問い合わせ下さい。"
            ]
        },
        governing:{
            title:"5. 準拠法及び管轄",
            textItem:"利用規約は、中華民国の法律に準拠し、解釈されるものとします、法律と抵触ルールないのは前提で。 このウェブサイトから生じる又は関連するユーザーとMPT Solutionの間のクレーム又は紛争は、中華民国、台湾、台北の地方裁判所の専属管轄権に従うものとします。"
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/jp.js